import React from 'react';
import { BiLink, BiButton } from '../../../biLogger';
import s from './StatLink.scss';
export var StatLink = function (_a) {
    var link = _a.link, onClick = _a.onClick, children = _a.children, id = _a.id, biEventData = _a.biEventData;
    if (!children) {
        return null;
    }
    if (!link) {
        if (!onClick) {
            return React.createElement(React.Fragment, null, children);
        }
        return (React.createElement(BiButton, { id: id, onClick: onClick, className: s['link'], biData: biEventData }, children));
    }
    return (React.createElement(BiLink, { id: id, href: link.href, onClick: onClick, target: link.target, download: link.isDownload, className: s['link'], biData: biEventData }, children));
};
StatLink.displayName = 'StatLink';
export default StatLink;
//# sourceMappingURL=StatLink.js.map